/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrderInfoForSimpleFromRocketVo } from './OrderInfoForSimpleFromRocketVo';
import {
    OrderInfoForSimpleFromRocketVoFromJSON,
    OrderInfoForSimpleFromRocketVoFromJSONTyped,
    OrderInfoForSimpleFromRocketVoToJSON,
    OrderInfoForSimpleFromRocketVoToJSONTyped,
} from './OrderInfoForSimpleFromRocketVo';

/**
 * 
 * @export
 * @interface ResponseOrderInfoForSimpleFromRocketVo
 */
export interface ResponseOrderInfoForSimpleFromRocketVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseOrderInfoForSimpleFromRocketVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseOrderInfoForSimpleFromRocketVo
     */
    message?: string;
    /**
     * 
     * @type {OrderInfoForSimpleFromRocketVo}
     * @memberof ResponseOrderInfoForSimpleFromRocketVo
     */
    data?: OrderInfoForSimpleFromRocketVo;
}

/**
 * Check if a given object implements the ResponseOrderInfoForSimpleFromRocketVo interface.
 */
export function instanceOfResponseOrderInfoForSimpleFromRocketVo(value: object): value is ResponseOrderInfoForSimpleFromRocketVo {
    return true;
}

export function ResponseOrderInfoForSimpleFromRocketVoFromJSON(json: any): ResponseOrderInfoForSimpleFromRocketVo {
    return ResponseOrderInfoForSimpleFromRocketVoFromJSONTyped(json, false);
}

export function ResponseOrderInfoForSimpleFromRocketVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseOrderInfoForSimpleFromRocketVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : OrderInfoForSimpleFromRocketVoFromJSON(json['data']),
    };
}

export function ResponseOrderInfoForSimpleFromRocketVoToJSON(json: any): ResponseOrderInfoForSimpleFromRocketVo {
    return ResponseOrderInfoForSimpleFromRocketVoToJSONTyped(json, false);
}

export function ResponseOrderInfoForSimpleFromRocketVoToJSONTyped(value?: ResponseOrderInfoForSimpleFromRocketVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': OrderInfoForSimpleFromRocketVoToJSON(value['data']),
    };
}

